import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Subject, Observable } from 'rxjs';
import { Supplier } from '../../_models/supplier';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SupplierService {
  baseUrl = environment.apiUrl;
  supplierSelected = new Subject<Supplier>();
  constructor(private http: HttpClient) {}
  changeEditState(cc: Supplier) {
    this.supplierSelected.next(cc);
  }

  getSuppliersFull(): Observable<Supplier[]> {
    return this.http.get<Supplier[]>(this.baseUrl + 'supplier/list/full');
  }
  getSupplier(id): Observable<Supplier> {
    return this.http.get<Supplier>(this.baseUrl + 'supplier/' + encodeURIComponent(id));
  }
  getLatestCode(): Observable<string> {
    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
    const requestOptions: Object = {
      headers,
      responseType: 'text'
    };
    return this.http.get<string>(this.baseUrl + 'supplier/lastcode', requestOptions);
  }
  updateSupplier(id: string, supplier: Supplier) {
    return this.http.put(this.baseUrl + 'supplier/' + encodeURIComponent(id), supplier);
  }
  createSupplier(supplier: Supplier) {
    return this.http.post(this.baseUrl + 'supplier', supplier);
  }
  deleteSupplier(id: string) {
    return this.http.delete(this.baseUrl + 'supplier/' + encodeURIComponent(id));
  }
}
